import React from "react";
import { I18nextProvider } from "react-i18next";
import { createAppModel, getConfig, start } from "zebdsh.appframe";
import { authentication, b2cGet } from "zebdsh.login.authentication";
import { App } from "./App";
import i18n from "./i18n";
import { getLanguagePrefix, LANG_UNDEFINED, getUserLanguage } from "./utils";
import { CookiesProvider } from "react-cookie";
const appUrl = document.URL;
const lang = getLanguagePrefix(appUrl);
const config = getConfig();
let techName = config["technicalName"];
const theme = new URL(location.href).searchParams.get("client");
const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
};
fetch("/api/reporting/v1.0/" + lang + "/reports/" + techName + "/name/", { headers: headers }).then((response) => {
    console.log(response);
    if (!response.ok) {
        console.error("Error while getting report meta");
        init(techName ? techName : "", true);
    }
    else {
        response.json().then((data) => {
            document.title = data.name + " | zeb digital services";
            init(data.name, data.requires_licence);
        });
    }
});
let userLang = lang;
if (lang === LANG_UNDEFINED) {
    userLang = getUserLanguage();
}
const startApp = (appModel, name) => {
    start(React.createElement(CookiesProvider, null,
        React.createElement(I18nextProvider, { i18n: i18n },
            React.createElement(App, { appModel: appModel, appName: techName, localizedName: name, appUrl: appUrl, reportServiceLang: lang, userLang: userLang }))));
};
const init = (name, requiresLicence) => {
    const config = getConfig();
    const authProps = Object.assign({}, config.auth);
    authProps["isAuthenticationRequired"] = requiresLicence;
    authentication.initialize(authProps);
    authentication.login(() => {
        const successCallback = (branding) => {
            var _a;
            const appModel = createAppModel({
                title: { default: name },
                theme: {
                    palette: branding.appframe_color ? { primary: { main: branding.appframe_color } } : null,
                    fontFamily: branding.font_family_headline,
                },
                omitDshIntegration: true,
                logo: (_a = branding.logo) !== null && _a !== void 0 ? _a : null,
            });
            startApp(appModel, name);
        };
        const failureCallback = () => {
            startApp(createAppModel({
                title: { default: name },
            }), name);
        };
        b2cGet("/api/reporting/v1.0/branding/", successCallback, failureCallback);
    });
};
